export default __webpack_public_path__ + "static/media/chat.05d98849.svg";